import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=38c17840&scoped=true&"
import script from "./medical.vue?vue&type=script&lang=js&"
export * from "./medical.vue?vue&type=script&lang=js&"
import style0 from "./medical.vue?vue&type=style&index=0&id=38c17840&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c17840",
  null
  
)

export default component.exports